import { formatToDateTamplate } from '@/common/functions/dateFormater';
import { SPEND_SOURCES } from '@/common/constants/spend_sources';

export const getRaws = (spends) =>
	spends?.map((spend, i) => (
		<tr key={i}>
			<td>{formatToDateTamplate(spend.date_for)}</td>
			<td>
				{spend.account?.source &&
					SPEND_SOURCES.find((opt) => opt.value === spend.account?.source)
						?.label}
			</td>
			<td>{spend.market?.name} </td>
			<td>{spend.product?.name} </td>
			<td>{spend.spend} </td>
		</tr>
	));
